module.exports = __webpack_public_path__ + "static/media/holyoysterspic.419c020b.jpg";